import React from "react";
import { clsx } from "clsx";
import { Sparkles, PencilIcon } from "lucide-react";

interface Props {
  processing: boolean;
  isEdit: boolean;
}

export const StatusBadge: React.FC<Props> = ({ processing, isEdit }) => {
  // Only show badge when processing or editing
  if (!processing && !isEdit) {
    return null;
  }

  return (
    <div
      className={clsx("flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium", {
        "bg-coral/15 text-coral": processing || isEdit,
      })}
    >
      {processing ? (
        <>
          <Sparkles className="h-3.5 w-3.5" />
          Processing
        </>
      ) : (
        <>
          <PencilIcon className="h-3.5 w-3.5" />
          Editing
        </>
      )}
    </div>
  );
};
